import React from "react";
import { Image, Modal, Text, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppImages } from "../../utility/AppImages";
import { AppFontStyle } from "../../styles/AppFontStyle";
import Separator from "../Separator";

const DisputeDetailsPopup = ({
  disputeDetailsPopup,
  setDisputeDetailsPopup,
}) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  return (
    <Modal
      visible={disputeDetailsPopup}
      transparent={true}
      animationType="fade"
      onRequestClose={() => setDisputeDetailsPopup(false)}
    >
      <View
        style={{
          flex: 1,
          backgroundColor: AppColors.blackTrans_000000a8,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TouchableOpacity
          style={{ position: "absolute", width: "100%", height: "100%" }}
          onPress={() => setDisputeDetailsPopup(false)}
        />
        <View
          style={[
            styles.modalContent,
            {
              width:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "90%"
                  : "50%",
            },
          ]}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text
              style={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_16
                  : AppFontStyle.BOLD_ANYBODY_24
              }
            >
              Dispute Details
            </Text>

            <TouchableOpacity
              onPress={() => setDisputeDetailsPopup(false)}
              activeOpacity={0.5}
              style={{
                padding: 7,
                backgroundColor: AppColors.gray_212222,
                borderWidth: 1,
                borderColor: AppColors.grayColor_393939,
                borderRadius: 6,
              }}
            >
              <Image
                source={AppImages.icCloseWhiteSvg}
                style={{
                  height: 16,
                  width: 16,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
          </View>
          <Separator
            color={AppColors.black_2D2733}
            height={1}
            marginTop={12}
            marginBottom={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 12
                : 24
            }
            marginHorizontal={0}
          />
          <View
            style={{
              padding:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 12
                  : 24,
              borderRadius: 24,
              backgroundColor: AppColors.purple_453B50,
              gap:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 8
                  : 24,
            }}
          >
            <View style={{ flexDirection: "row", gap: 24 }}>
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.MEDIUM_ANYBODY_14
                    : AppFontStyle.MEDIUM_ANYBODY_16,
                  {
                    color: AppColors.gray_C4C4C4,
                  },
                ]}
              >
                Event Name:
              </Text>{" "}
              <Text
                style={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.SEMIBOLD_ANYBODY_14
                    : AppFontStyle.SEMIBOLD_ANYBODY_18
                }
              >
                Event Name here
              </Text>{" "}
            </View>
            <View style={{ flexDirection: "row", gap: 24 }}>
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.MEDIUM_ANYBODY_14
                    : AppFontStyle.MEDIUM_ANYBODY_16,
                  {
                    color: AppColors.gray_C4C4C4,
                  },
                ]}
              >
                Your Claim:
              </Text>{" "}
              <Text
                style={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.SEMIBOLD_ANYBODY_14
                    : AppFontStyle.SEMIBOLD_ANYBODY_18
                }
              >
                you claim a win
              </Text>{" "}
            </View>
            <View style={{ flexDirection: "row", gap: 24 }}>
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.MEDIUM_ANYBODY_14
                    : AppFontStyle.MEDIUM_ANYBODY_16,
                  {
                    color: AppColors.gray_C4C4C4,
                  },
                ]}
              >
                Submitted Evidence:
              </Text>{" "}
              <Text
                style={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.SEMIBOLD_ANYBODY_14
                    : AppFontStyle.SEMIBOLD_ANYBODY_18
                }
              >
                Image
              </Text>{" "}
            </View>
            <View style={{ alignItems: "center" }}>
              <Image
                source={AppImages.imgDisputeDetails}
                style={{
                  height:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 115
                      : 219,
                  width:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 200
                      : 420,
                  resizeMode: "contain",
                }}
              />
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default DisputeDetailsPopup;
const useStyles = CreateResponsiveStyle(
  {
    modalContent: {
      backgroundColor: AppColors.black_121212,
      padding: 24,
      borderRadius: 24,
      elevation: 5,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: { modalContent: { padding: 12 } },
    [DEVICE_SIZES.XS]: { modalContent: { padding: 12 } },
  }
);
